import addAdmin from './addAdmin';
export default addAdmin;